import { Footer } from '../../../../atoms/Footer/Footer';
import { styled } from '../../../../../core/theme/styled';

type StyledInputsContainerProps = {
  flexRow?: boolean;
};

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  ${Footer} {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const StyledInputsContainer = styled.div<StyledInputsContainerProps>`
  display: flex;
  flex-shrink: 0;
  flex-direction: ${(props) => (props.flexRow ? 'row' : 'column')};
  gap: ${(props) => props.theme.sizes.normal};
`;
